import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";

const CREATE = "/requests/create";

export const createRequest = async (data) => {
  try {
    await axios
      .post(`${CREATE}`, data)
      .then((res) => {
        // store.dispatch({ type: "CREATE_Requests", data: res.data.data });
      })
      .catch((e) => {
        console.log(e);
      });
  } catch (e) {
    throw e;
  }
};

export const fetchRequests = async (status) => {
  try {
    const centerId=JSON.parse(localStorage.getItem('centerId')).centerId

    //!get today and yesterday
    const res = await axios.get(`/requests?centerId=${centerId}&startDate=${dayjs().subtract(1, 'day').format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}`);
    console.log(res.data)
    store.dispatch({ type: "FETCH_REQUESTS", data: res.data });
  } catch (e) {
    throw e;
  }
};
